"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisualizationInterface = void 0;
var _Observable = _interopRequireDefault(require("./CommonUtils/Observable"));
var _Constants = require("./Constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VisualizationInterface = exports.VisualizationInterface = /*#__PURE__*/function () {
  function VisualizationInterface() {
    var _this = this;
    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, VisualizationInterface);
    _defineProperty(this, "_basePath", "");
    _defineProperty(this, "_itemPath", "");
    _defineProperty(this, "_materialVariantPath", "");
    _defineProperty(this, "_isInitialized", false);
    _defineProperty(this, "_screenshottingInProgress", false);
    _defineProperty(this, "_screenshotPromise", null);
    _defineProperty(this, "observable", new _Observable["default"](this));
    _defineProperty(this, "dispatchErrorEvent", function (data) {
      _this.observable.dispatch(_Constants.EventTypes.Error, data);
    });
    _defineProperty(this, "onLoadError", function (url) {
      var errorMessage = "Could not load file: ".concat(url);
      // eslint-disable-next-line no-console
      console.error(errorMessage);
      _this.observable.dispatch(_Constants.EventTypes.LoadError, {
        url: url,
        screenshot: !!_this._screenshottingInProgress
      });
    });
    _defineProperty(this, "onLoadStart", function () {
      return _this.observable.dispatch(_Constants.EventTypes.LoadStart, {
        screenshot: !!_this._screenshottingInProgress
      });
    });
    _defineProperty(this, "onLoadFinished", function () {
      return _this.observable.dispatch(_Constants.EventTypes.LoadFinished, {
        screenshot: !!_this._screenshottingInProgress
      });
    });
    if (cfg.basePath) {
      this.setBasePath(cfg.basePath);
    }
  }

  /**
   * Initializes the visualization
   * This function is called from the container component.
   * It provides the opportunity to add any visualization element to the container, and do initial setup if needed.
   * @param {HTMLElement} [container=<div>]
   * @param {boolean} [useDefaultSetup]
   */
  // eslint-disable-next-line no-unused-vars
  _createClass(VisualizationInterface, [{
    key: "init",
    value: function init(container, useDefaultSetup) {}

    /**
     * Adds the visualization element to the container
     * This function is called from the container component, when the visualization is already initialized.
     * (see isInitialized method below)
     * This function should add the visualization element to the container, and do other updates if needed.
     * @param container
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "addToContainer",
    value: function addToContainer(container) {}
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      return this._isInitialized;
    }

    /**
     * Sets the base path for loading models
     * @see getModelPaths
     * @param {string} path
     */
  }, {
    key: "setBasePath",
    value: function setBasePath(path) {
      this._basePath = path;
    }

    /**
     * Sets the item path for loading models
     * @see getModelPaths
     * @param {string} path
     */
  }, {
    key: "setItemPath",
    value: function setItemPath(path) {
      this._itemPath = path;
    }
  }, {
    key: "updateItemPath",
    value: function updateItemPath(path) {
      this.setItemPath(path);
      return this.loadModel();
    }

    /**
     * Sets the material variant path for loading models
     * @see getModelPaths
     * @param {string} path
     */
  }, {
    key: "setMaterialVariantPath",
    value: function setMaterialVariantPath(path) {
      this._materialVariantPath = path;
    }
  }, {
    key: "updateMaterialVariantPath",
    value: function updateMaterialVariantPath(path) {
      this.setMaterialVariantPath(path);
      return this.updateMaterial();
    }

    /**
     * A helper function to split the given relative url to path and fileName parts
     * @param {string|{path: string, fileName: string}} value
     * @returns {{path: string, fileName: string}}
     */
  }, {
    key: "getPathAndFileName",
    value: function getPathAndFileName(value) {
      if (_typeof(value) === "object" && value.path && value.fileName) {
        return value;
      } else if (typeof value === "string") {
        var matches = value.match(/(.*\/)?([^/]+)$/);
        if (matches) {
          return {
            path: matches[1],
            fileName: matches[2]
          };
        }
        throw new Error("Could not match path and filename for the string: '".concat(value, "', is it a valid path?"));
      }
      throw new Error("Unknown path value type given in getPathAndFileName. " + "It should be a string or an object { path, fileName }");
    }

    /**
     * Sets the canvas size
     * @param {number} width
     * @param {number} height
     * @param {boolean} rerender
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "setSize",
    value: function setSize(_ref) {
      var width = _ref.width,
        height = _ref.height;
      var rerender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    }

    /**
     * Loads the model from the pre-configured paths
     * Implement this function to load resources and add them to the visualization.
     * @see updateItemPath
     * @see setItemPath
     */
  }, {
    key: "loadModel",
    value: function loadModel() {}

    /**
     * Updates the material on the model
     * Implement this function to load a material and apply it on the visualization object.
     * @see updateMaterialVariantPath
     * @see setMaterialVariantPath
     */
  }, {
    key: "updateMaterial",
    value: function updateMaterial() {}

    /**
     * Handle updates of design area list if needed in the custom implementation
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: "updateDesignAreaList",
    value: function updateDesignAreaList(designAreaList) {}

    /**
     * Calls the given drawing function for custom drawing implementations
     * It provides the drawing context (among with other custom parameters if needed) in the callback function.
     * @param {function(ctx: CanvasRenderingContext2D, image: HTMLImageElement)} drawingFn
     * @param {boolean} updateAlpha Indicates that the alpha map needs to be updated
     * @param {boolean} clearTexture Indicates that the texture has to be cleared before drawing
     * @param {string|undefined} materialName Request for a specific material texture context
     */
  }, {
    key: "getDrawingContext",
    value: function getDrawingContext(drawingFn) {
      var updateAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var clearTexture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var materialName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    }

    /**
     * Redraw the visualization
     */
  }, {
    key: "render",
    value: function render() {}
  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return false;
    }
  }, {
    key: "getScreenshots",
    value:
    /**
     * A function to create screenshots from the visualization
     * It can include switching views and async loading of resources, so the results are better returned
     * in a callback function. If there is no result, simply return null.
     * @param {function} callback The callback function should get the generated screenshots in the first arg
     * @param {object} options The options object to pass extra data
     */
    // eslint-disable-next-line no-unused-vars
    function () {
      var _getScreenshots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback, options) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              callback && callback(null);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getScreenshots(_x, _x2) {
        return _getScreenshots.apply(this, arguments);
      }
      return getScreenshots;
    }()
  }, {
    key: "getScreenshotsSync",
    value: function () {
      var _getScreenshotsSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this._screenshotPromise;
            case 3:
              _context2.next = 7;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
            case 7:
              this._screenshotPromise = this.getScreenshots.apply(this, _args2);
              _context2.next = 10;
              return this._screenshotPromise;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function getScreenshotsSync() {
        return _getScreenshotsSync.apply(this, arguments);
      }
      return getScreenshotsSync;
    }()
  }, {
    key: "getScreenshotsReady",
    value: function getScreenshotsReady() {
      return this._screenshotPromise;
    }

    /**
     * This function has to be called when the visualization instance is not needed any longer
     * The implementation has to free all the allocated resources including the removal of the element appended
     * to the container, if there is any
     */
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);
  return VisualizationInterface;
}();